module.exports = __webpack_public_path__ + "media/images/front/special-99fad4b0b536d05421bddd091280956f.png";